"use strict";

window.$ = window.jQuery;

import App from "./modules/App";

(function ($) {
    $(document).ready(function () {
        App.init();
    });
})(jQuery);
